/*
 * <xo-random-pick> — reveals ONE random child candidate, hides the rest.
 *
 * Used by the cart cross-sell "random slot". The pool is rendered server-side
 * (already filtered against the cart); this picks one in the browser. Because
 * connectedCallback fires every time the element is inserted into the DOM — on
 * first page load AND on each cart AJAX re-render — the pick re-rolls on every
 * render with zero full-page-cache interaction.
 *
 * Candidates are stacked in one grid cell and hidden via `visibility` (see
 * cart-cross-sell.css) so the slide height never changes when the pick swaps.
 */
(function () {
  if (!window.customElements || customElements.get('xo-random-pick')) return;

  customElements.define(
    'xo-random-pick',
    class extends HTMLElement {
      connectedCallback() {
        var items = this.querySelectorAll(':scope > .xo-cart-cross-sell__candidate');
        if (!items.length) return;
        var pick = Math.floor(Math.random() * items.length);
        for (var i = 0; i < items.length; i++) {
          items[i].classList.toggle('is-hidden', i !== pick);
        }
      }
    }
  );
})();
